import { render, staticRenderFns } from "./Snack.htm?vue&type=template&id=016d22cb&scoped=true&"
import script from "./Snack.ts?vue&type=script&lang=js&"
export * from "./Snack.ts?vue&type=script&lang=js&"
import style0 from "./Snack.scss?vue&type=style&index=0&id=016d22cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016d22cb",
  null
  
)

export default component.exports